import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Modal, ModalBody } from "react-bootstrap";
import isNull from '../../../../../../../../../../../../utils/NullChecking'
import { ServerRequestProtected } from '../../../../../../../../../../../../utils/ServerDataRequest';
import NotificationHandler from '../../../../../../../../../../../../utils/NotificationHandler';
import { enumUtil } from '../../../../../../../../../../../../utils/Enum';
import FormValidator from '../../../../../../../../../../../../utils/FormValidator';
import DatePicker from '../../../../../../../../../../../General/DatePicker';
import ModalHeader from '../../../../../../../../../../../Setup/Shared/ModalHeader';
import SuperSearchList from '../../../../../../../../../../../shared/SuperSearch/SuperSearchList';
import { GenderIdentity as GenderIdentityData } from '../../../../../../../../../../../../utils/Constants';
import DeleteConfirmatiom from '../../../../../../../../../../../General/DeleteConfirmation';
import Loader from '../../../../../../../../../../../shared/Loader/Loader';

// const GenderIdentityData = [
//     { display: 'Male', value: 'Male' },
//     { display: 'Female', value: 'Female' },
//     { display: 'Transgender Male/Trans Man/Female-to-Male', value: 'TransgenderMale' },
//     { display: 'Transgender Female/Trans Woman/Male-to-Female', value: 'TransgenderFemale' },
//     { display: 'Genderqueer, neither exclusively Male nor Female', value: 'Genderqueer' },
//     { display: 'Additional gender category or other', value: 'AdditionalGenderCategory' },
//     { display: 'Patient declines to specify', value: 'DeclinesToSpecify' },
//     { display: 'Other (Please specify)', value: 'Other' },
// ];


const AddNewGenderIdentity = (props) => {
    const { isOpenGenderIdentity, onClose, genderIdentityData, setIsRecordSaved, patientID, IsEditAllowed, onDeleteGenderIdentity } = { ...props }
    const API_URL = enumUtil.controller.General
    let GenderIdentity_Modal = {
        GenderIdentity: genderIdentityData?.GenderIdentity || "",
        Notes: genderIdentityData?.Notes || "",
    }
    let valModal = {}
    let ValidationModal = {
        GenderIdentityVal: "",
        NotesVal: "",
    }
    const [isOpenDeleteAlert, setisOpenDeleteAlert] = useState(false);
    const [genderIdentityID, setGenderIdentityID] = useState();
    const [genderIdentityValidationModal, setGenderIdentityValidationModal] = useState(ValidationModal)
    const [genderIdentitySaveUpdateModal, setGenderIdentitySaveUpdateModal] = useState({})
    const [mainGenderIdentityModal, setMainGenderIdentityModal] = useState(GenderIdentity_Modal);
    const [isLoading, setIsLoading] = useState(false)
    const [onGenderIdentitySaved, setOnGenderIdentitySaved] = useState(false)
    const [del, setDel] = useState(false)

    useEffect(() => {
        // setPracticeID(PracticeID)
        if (genderIdentityData.PatientID != null) {
            setDel(true)
            setGenderIdentityID(genderIdentityData.PatientID)
        } else {
            if (!onGenderIdentitySaved) {
                setGenderIdentityID("0");
                setDel(false)
            } else {
                setDel(true)
            }
        }
    }, [genderIdentityID])

    const GenderIdentityValidation = async () => {
        let notesVal = GenderIdentityData.find(item => item.display === mainGenderIdentityModal.GenderIdentity)?.value || "";

        let ValidationModal = {
            GenderIdentityVal: FormValidator(
                mainGenderIdentityModal.GenderIdentity,
                enumUtil.enumValidationType.Required,
                'Gender Identity',
            ),
            ...(notesVal === "Other" ?
                {
                    NotesVal: FormValidator(
                        mainGenderIdentityModal.Notes,
                        enumUtil.enumValidationType.Required,
                        'Notes',
                    )
                } : {})

        }
        await setGenderIdentityValidationModal(ValidationModal)
        valModal = ValidationModal
    }
    const handleSaveGenderIdentity = async () => {
        if(!IsEditAllowed) return;
        await GenderIdentityValidation()
        let validation = FormValidator([valModal], enumUtil.enumValidationType.NullCheck)
        if (validation) {
            NotificationHandler('Fill Required Fields', enumUtil.enumtoaster.error)
            return
        } else {
            setGenderIdentitySaveUpdateModal(genderIdentitySaveUpdateModal)
            let data = {
                PatientID: patientID,
                HistoryType: "Social History",
                HistorySubType: "Gender Identity",
                ...genderIdentitySaveUpdateModal
            };

            let saveModal = {
                TableName: enumUtil.enumAPITableName.PatientHistory,
                ID: patientID,
                Data: { ...data },
            }
            setIsLoading(true)
            ServerRequestProtected(API_URL + "/SaveSingleRecord", 'post', saveModal)
                .then((response) => {
                    if (!isNull(response.id)) {
                        setIsLoading(false)
                        NotificationHandler(`Record Saved Successfully`, enumUtil.enumtoaster.success)
                        setIsRecordSaved(true);
                        onClose()
                    }
                }).catch((error) => {
                    setIsLoading(false)
                    console.log('error', error);
                    NotificationHandler(error.response.data, enumUtil.enumtoaster.error)
                })
        }
    }

    const handleChange = (e) => {
        let { name, value } = e.target
        let modal = { ...mainGenderIdentityModal };
        let saveModal = { ...genderIdentitySaveUpdateModal }
        modal[name] = value
        setMainGenderIdentityModal(modal)
        for (var property in GenderIdentity_Modal) {
            if (name === property) {
                saveModal[name] = value
            }
        }
        setGenderIdentitySaveUpdateModal(saveModal)
    }

    const GenderIdentityName = () => {
        return (
            <p className="heading">Add New Gender Identity</p>
        )
    }
    const handleSelectedData = (selectedData, name, type, mode) => {
        // setIs(true)
        let modal = { ...mainGenderIdentityModal };
        if (type === 'client' && !isNull(selectedData)) {
            if (name === "GenderIdentity") {
                modal[name] = selectedData.display
                genderIdentitySaveUpdateModal[name] = selectedData.value + "";
                // setProviderID(selectedData.value + "")
            } else if (name === "ProviderID") {
                modal[name] = selectedData.display
                genderIdentitySaveUpdateModal[name] = selectedData.value + "";
                // setProviderID(selectedData.value + "")
            }
        } else if (type === 'server' && !isNull(selectedData)) {
            // if (name === 'POSCode') {
            //     LocationSaveUpdateModal[name] = selectedData.ID
            //     setPOS(selectedData.ID)


        } else {
            modal[name] = ''
            genderIdentitySaveUpdateModal[name] = ''
        }
        setMainGenderIdentityModal(modal)
        return selectedData
    }
    const handleDeleteModal = () => {
        setisOpenDeleteAlert(true)
    }
    const onCloseDelete = () => {
        setisOpenDeleteAlert(false);
    }
    const onDelete = () => {
        setIsRecordSaved(true);
        setisOpenDeleteAlert(false);
        onClose();
    }

        let DeleteConfirmation = "";
        if (isOpenDeleteAlert) {
            DeleteConfirmation = (
                <DeleteConfirmatiom
                    isOpenAlert={isOpenDeleteAlert}
                    hideReason={true}
                    API_URL={API_URL}
                    TableName={enumUtil.enumAPITableName.GenderIdentity}
                    ID={String(patientID)}
                    onCloseDelete={onCloseDelete}
                    onClose={onDelete}
                />
            );
        }
        let DeletePopup = "";
        if (del) {
            DeletePopup = (
                <button
                    className={
                        props?.IsDeleteAllowed
                          ? 
                        "btn-icon-transparent"
                          : 
                          "btn-icon-transparent delete-btn-disabled"
                    } onClick={handleDeleteModal}>
                    <span className="icon"><i className="icon-delete"></i></span>
                    <span className="title">Delete</span>
                </button>
            );
        }

    return (
        <Modal show={isOpenGenderIdentity} onHide={isOpenGenderIdentity} backdrop="static" keyboard={false} centered dialogClassName="hk-modal-v1 ar_ehr_problems ar_new-popup-design">
            <Modal.Body>
                {isLoading ? <Loader/> : null}
                {DeleteConfirmation}
                <ModalHeader HideAuditIcon={"PatEncounter"} HeaderName={GenderIdentityName} isOpenDeleteAlert={isOpenDeleteAlert} onCloseDelete={onCloseDelete} DeletePopup={DeletePopup} isClosed={onClose} />
                <div className="">
                    <div className=''>
                        <div className="input mb-12">
                            <div className="form-group input">
                                <label className="pb-3px">Gender Identity</label>
                                <div className={`input form-group ar-multiple-br m-0 ${genderIdentityValidationModal.GenderIdentityVal ? 'error' : ''}`}>
                                    <SuperSearchList
                                        type="client"
                                        id='GenderIdentity'
                                        name='GenderIdentity'
                                        searchValue={mainGenderIdentityModal.GenderIdentity}
                                        data={GenderIdentityData}
                                        onChange={handleChange}
                                        getSelectedData={handleSelectedData}
                                        icon={'Simple'}
                                        sup_btn='sup_btn'
                                        sup_inp='superSearchVisitInp'
                                        inputError={genderIdentityValidationModal.GenderIdentityVal}
                                    />
                                    {genderIdentityValidationModal.GenderIdentityVal}
                                </div>
                            </div>
                        </div>
                        <div className={`input mb-0 ${genderIdentityValidationModal.NotesVal ? 'error' : ''}`}>
                            <label className="pb-3px">Notes</label>
                            <textarea
                                className="form-control"
                                id='Notes'
                                name='Notes'
                                rows="3"
                                onChange={handleChange}
                                value={mainGenderIdentityModal.Notes}
                            />
                            {genderIdentityValidationModal.NotesVal}
                        </div>
                    </div>
                </div>
            </Modal.Body>
            <div className="d-flex align-items-center pb-15 px-10 pt-2 br-top-1 za_br_light  ar_footer justify-content-end gap-2">
                <button className='btn btn-outline  px-10 h-100 dark-clr' onClick={onClose}>Cancel</button>
                <button className={`btn btn-validate px-10 h-100 ${IsEditAllowed ? '' : 'disable'}`} onClick={handleSaveGenderIdentity}>Save</button>
            </div>
        </Modal>
    )
}

export default AddNewGenderIdentity